var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('desform-view',_vm._b({on:{"success":_vm.handleSuccess}},'desform-view',_vm.viewProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }